// src/services/userRoleService.js

import apiClient from "./apiClient";
const API_URL = `/ipd-operations`; // Use relative path since apiClient has baseURL

export const create = async (operationData) => {
  // apiClient will automatically add organizationId via interceptor
  const response = await apiClient.post(`${API_URL}/create`, operationData);
  return response.data;
};

export const updateWard = async (id, wardData) => {
  // apiClient will automatically add organizationId via interceptor
  const response = await apiClient.put(`${API_URL}/${id}`, wardData);
  return response.data;
};

export const getByPatientAssignmentId = async (patientId) => {
  try {
    // apiClient will automatically add organizationId as query param via interceptor
    const response = await apiClient.get(`${API_URL}/assignment/${patientId}`);
    return response.data;
  } catch (error) {
    if (
      error.response?.status === 500 &&
      (error.response?.data?.message?.includes("Failed to retrieve") ||
        error.response?.data?.message?.includes("from table") ||
        error.response?.data?.message?.includes("does not exist"))
    ) {
      console.warn(
        "Organization-specific IPD operations assignment table not found, returning empty array:",
        error.response.data?.message
      );
      return [];
    }
    throw error;
  }
};

export const getByAdmission = async (admissionId) => {
  try {
    // apiClient will automatically add organizationId as query param via interceptor
    const response = await apiClient.get(`${API_URL}/by-admission/${admissionId}`);
    return response.data;
  } catch (error) {
    if (
      error.response?.status === 500 &&
      (error.response?.data?.message?.includes("Failed to retrieve") ||
        error.response?.data?.message?.includes("from table") ||
        error.response?.data?.message?.includes("does not exist"))
    ) {
      console.warn(
        "Organization-specific IPD operations table not found, returning empty array:",
        error.response.data?.message
      );
      return [];
    }
    throw error;
  }
};

export default {
  create,
  getByPatientAssignmentId,
  getByAdmission
} 